import { render, staticRenderFns } from "./passport.vue?vue&type=template&id=1a7ff5c6&scoped=true&"
var script = {}
import style0 from "./passport.vue?vue&type=style&index=0&id=1a7ff5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7ff5c6",
  null
  
)

export default component.exports